import {
  fetchPublicMyHomeV3CreateRealty,
  IPublicMyHomeV3CreateRealtyRequest,
} from '../../../common/repositories/price-estimator/my-home/v3/create-realty';
import { IApplicationContext } from '../../types/applicationContext';
import { createSubmitFlatDataMapper } from './mappers';

export const fetchFlatData = async (parameters: IPublicMyHomeV3CreateRealtyRequest, context: IApplicationContext) => {
  try {
    const res = await fetchPublicMyHomeV3CreateRealty({
      parameters,
      httpApi: context.httpApi,
      mappers: createSubmitFlatDataMapper(),
    });

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    context.logger.error(error, { message: 'error in fetchCreateRealty' });

    throw error;
  }
};
